// @flow
import { creativityMediaModel } from '../../../../../services/creativityMediaModel'

const productImage = require('./free-damm-tostada.jpg')
const allTwoEs = require('./static-es.png')
const allTwoCa = require('./static-ca.png')
const allFourEs = require('./animated-es.gif')
const allFourCa = require('./animated-ca.gif')
const catalogTwoEs = require('./static-es.png')
const catalogTwoCa = require('./static-ca.png')
const catalogFourEs = require('./animated-es.gif')
const catalogFourCa = require('./animated-ca.gif')

const model = creativityMediaModel({
  catalogID: 'beer',
  allTwoEs,
  allTwoCa,
  allFourEs,
  allFourCa,
  catalogTwoEs,
  catalogTwoCa,
  catalogFourEs,
  catalogFourCa
})

type Params = {
  catalogID: string,
  numberOfColumns: number,
  language: string
}

export default {
  productImage,
  creativityMedia: (params: Params) =>
    model[params.catalogID][params.numberOfColumns][params.language]
}
